import React from 'react';
import { formatSrednayaVysota, formatUklon } from './utils';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const PodlesokSection = ({
  displayData,
  handbooks,
  updatePodlesokItem,
  openPicker,
  podlesokTableScrollRef,
  podlesokScrollPosition,
  handlePodlesokSliderChange,
  handlePodlesokTableScroll
}) => {
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Подлесок</h4>
      </div>
      <div 
        ref={podlesokTableScrollRef}
        onScroll={handlePodlesokTableScroll}
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '6px'
        }}>
        <table className="table" style={{ 
          minWidth: '1700px',
          width: 'max-content',
          marginBottom: 0
        }}>
          <thead>
            <tr>
              <th style={{ minWidth: '150px', width: '150px' }}>Породы</th>
              <th style={{ minWidth: '100px', width: '100px' }}>Густота</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Средняя высота</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Состояние</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Рельеф. Форма</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Рельеф. Экспозиция</th>
              <th style={{ minWidth: '100px', width: '100px' }}>Рельеф. Уклон</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Эрозия. Вид</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Эрозия. Степень</th>
              <th style={{ minWidth: '180px', width: '180px' }}>Проведённые хозяйственные мероприятия</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Информация пользователя</th>
            </tr>
          </thead>
          <tbody>
            {displayData.podlesok.map((item, index) => (
              <tr key={item.id}>
                {/* Породы */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <input
                    type="text"
                    value={item.sostavpdl}
                    onChange={(e) => updatePodlesokItem(item.id, 'sostavpdl', e.target.value)}
                    className="form-control coordinate-field"
                    placeholder="Введите породы"
                  />
                </td>

                {/* Густота */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px' }}>
                  <input
                    type="text"
                    value={item.gustpdl}
                    onChange={(e) => updatePodlesokItem(item.id, 'gustpdl', e.target.value)}
                    className="form-control coordinate-field"
                    placeholder="Введите густоту"
                  />
                </td>

                {/* Средняя высота */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <DecimalInput
                    value={item.hpdl}
                    onChange={(e) => updatePodlesokItem(item.id, 'hpdl', toDecimalPoint(e.target.value))}
                    onBlur={(e) => {
                      const formatted = formatSrednayaVysota(e.target.value);
                      updatePodlesokItem(item.id, 'hpdl', formatted);
                    }}
                    className="form-control coordinate-field"
                    placeholder="0.0-999.9"
                  />
                </td>

                {/* Состояние */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <input
                    type="text"
                    value={item.sostpdl}
                    onChange={(e) => updatePodlesokItem(item.id, 'sostpdl', e.target.value)}
                    className="form-control coordinate-field"
                    placeholder="Введите состояние"
                  />
                </td>

                {/* Рельеф. Форма */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openPicker('reljeff', 21, item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        const handbook = handbooks.find(h => h.id === 21);
                        if (handbook && handbook.references && item.reljeff) {
                          const selectedOption = handbook.references.find(r => r.id.toString() === item.reljeff);
                          return selectedOption ? selectedOption.name : '';
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: item.reljeff ? '#495057' : '#6c757d',
                        fontStyle: item.reljeff ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Рельеф. Экспозиция */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openPicker('reljefeksp', 17, item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        const handbook = handbooks.find(h => h.id === 17);
                        if (handbook && handbook.references && item.reljefeksp) {
                          const selectedOption = handbook.references.find(r => r.id.toString() === item.reljefeksp);
                          return selectedOption ? selectedOption.name : '';
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: item.reljefeksp ? '#495057' : '#6c757d',
                        fontStyle: item.reljefeksp ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Рельеф. Уклон */}
                <td className="coordinate-cell" style={{ minWidth: '100px', width: '100px' }}>
                  <input
                    type="number"
                    min="0"
                    max="99"
                    value={item.reljefuklon}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 99)) {
                        updatePodlesokItem(item.id, 'reljefuklon', value);
                      }
                    }}
                    onBlur={(e) => {
                      const formatted = formatUklon(e.target.value);
                      updatePodlesokItem(item.id, 'reljefuklon', formatted);
                    }}
                    className="form-control coordinate-field"
                    placeholder="0-99"
                  />
                </td>

                {/* Эрозия. Вид */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openPicker('eroziavid', 28, item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        const handbook = handbooks.find(h => h.id === 28);
                        if (handbook && handbook.references && item.eroziavid) {
                          const selectedOption = handbook.references.find(r => r.id.toString() === item.eroziavid);
                          return selectedOption ? selectedOption.name : '';
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: item.eroziavid ? '#495057' : '#6c757d',
                        fontStyle: item.eroziavid ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Эрозия. Степень */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openPicker('eroziastep', 22, item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        const handbook = handbooks.find(h => h.id === 22);
                        if (handbook && handbook.references && item.eroziastep) {
                          const selectedOption = handbook.references.find(r => r.id.toString() === item.eroziastep);
                          return selectedOption ? selectedOption.name : '';
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: item.eroziastep ? '#495057' : '#6c757d',
                        fontStyle: item.eroziastep ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Проведённые хозяйственные мероприятия */}
                <td className="coordinate-cell" style={{ minWidth: '180px', width: '180px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openPicker('provlhm', 32, item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        const handbook = handbooks.find(h => h.id === 32);
                        if (handbook && handbook.references && item.provlhm) {
                          const selectedOption = handbook.references.find(r => r.id.toString() === item.provlhm);
                          return selectedOption ? selectedOption.name : '';
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: item.provlhm ? '#495057' : '#6c757d',
                        fontStyle: item.provlhm ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>

                {/* Информация пользователя */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <input
                    type="text"
                    value={item.itaks3}
                    onChange={(e) => updatePodlesokItem(item.id, 'itaks3', e.target.value)}
                    className="form-control coordinate-field"
                    placeholder="Введите информацию"
                  />
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Слайдер для прокрутки таблицы */}
      <div style={{ 
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '60px'
        }}>
          Прокрутка:
        </span>
        <input
          type="range"
          min="0"
          max="100"
          value={podlesokScrollPosition}
          onChange={handlePodlesokSliderChange}
          className="table-scroll-slider"
          style={{
            flex: 1
          }}
        />
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '30px',
          textAlign: 'right'
        }}>
          {Math.round(podlesokScrollPosition)}%
        </span>
      </div>
    </div>
  );
};

export default PodlesokSection;

